





























import Vue from 'vue';

export default Vue.extend({
  name: 'FirstStep',
  data: () => ({
    step: {
      total: '',
      description: '',
    },
  }),
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    nextStep() {
      this.$emit('next');
    },
  },
});
